<template>
    <div class="hk-pg-wrapper hk-auth-wrapper" style="min-height: 820px;" :style="mode==='dark'?'background: #080035; color: #fff':''">
        <nav aria-label="breadcrumb" class="container pt-20">
            <ol class="breadcrumb" :style="mode==='dark'?'background: #0c0050; color: #fff':''">
                <li class="breadcrumb-item"><a href="/#" :style="mode==='dark'?'color: #fff':''">{{ $t('login.breadcumb.inicio') }}</a></li>
                <li class="breadcrumb-item active" aria-current="page" :style="mode==='dark'?'color: #fff':''">{{ $t('login.breadcumb.login') }}</li>
            </ol>
        </nav>
        <div class="container">
            <h1 class="display-4 text-center mb-10">{{ $t('login.contenido.titulo') }}</h1>
            <p class="text-center mb-30">
                {{ $t('login.contenido.subtitulo') }}
            </p>
            <div class="alert alert-danger" v-if="error">{{ error }}</div>
            <div class="row">
                <div class="col-sm-6 col-12">
                    <form @submit.prevent="login">
                        <div class="form-group">
                            <input
                                    v-model="userCredentials.email"
                                    type="email"
                                    class="form-control"
                                    :placeholder="$t('login.contenido.placeholders.correo')"
                                    required
                                    autofocus
                                    :style="mode==='dark'?'background: #080035; color: #fff':''"
                            />
                        </div>
                        <div class="form-group">
                            <div class="input-group">
                                <input
                                        v-model="userCredentials.password"
                                        class="form-control"
                                        :placeholder="$t('login.contenido.placeholders.contrasena')"
                                        required
                                        :style="mode==='dark'?'background: #080035; color: #fff':''"
                                        :type="passwordFieldType"
                                />
                                <div class="input-group-append">
                                    <button class="btn btn-primary" type="button" @click="switchPasswordVisibility" style="width: 55px;">
                                        <i v-if="passwordFieldType === 'password'" class="fas fa-eye-slash fa-lg"></i>
                                        <i v-else class="fas fa-eye fa-lg"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="custom-control custom-checkbox mb-25">
                            <input
                                    id="remember_me"
                                    v-model="userCredentials.remember_me"
                                    class="custom-control-input"
                                    type="checkbox"
                                    :style="mode==='dark'?'background: #080035; color: #fff':''"
                            />
                            <label for="remember_me" class="custom-control-label font-14" :class="mode==='dark'?'text-white':'text-primary '">{{ $t('login.contenido.mantener') }}</label>
                        </div>
                        <recaptcha class="mb-25" ref="recaptcha" @verify="validateRecaptcha"></recaptcha>
                        <div v-if="loadBtnLogin" class="btn btn-primary d-block vld-parent pa-20">
                            <loading
                                    :active.sync="loadBtnLogin"
                                    :is-full-page="fullPage"
                                    :height="32"
                                    :color="color"
                            >
                            </loading>
                        </div>
                        <button v-if="!loadBtnLogin" class="btn btn-primary btn-block" type="submit" :disabled="!recaptcha">
                            {{ $t('login.contenido.iniciar') }}
                        </button>
                        <p class="text-center mt-15" :style="mode==='dark'?'text-white':'text-primary '">
                            {{ $t('login.contenido.olvidar') }}
                            <router-link :to="{ path: '/request' }" :class="mode === 'dark' ? 'text-white' : 'text-primary'">
                                <u>{{ $t('login.contenido.recuperar') }}</u>
                            </router-link>
                        </p>
                        <p class="text-center mt-15" :style="mode==='dark'?'text-white':'text-primary'">
                            {{ $t('login.contenido.sin_cuenta') }}
                            <router-link :to="{ path: '/signup' }" :class="mode === 'dark' ? 'text-white' : 'text-primary'">
                                <u>{{ $t('login.contenido.registrar') }}</u>
                            </router-link>
                        </p>
                    </form>
                </div>
                <div class="col-sm-6 col-12 pt-30 pt-sm-0">
                    <a class="btn btn-indigo btn-block btn-wth-icon" :href="API_URL + '/api/auth/facebook'">
                        <span class="icon-label"><i class="fab fa-facebook-square"></i></span>
                        <span class="btn-text">Facebook</span>
                    </a>
                    <a class="btn btn-danger btn-block btn-wth-icon mt-15" :href="API_URL + '/api/auth/google'">
                        <span class="icon-label"><i class="fab fa-google"></i></span>
                        <span class="btn-text">Google</span>
                    </a>
                    <a class="btn btn-blue btn-block btn-wth-icon mt-15" :href="API_URL + '/api/auth/twitter'">
                        <span class="icon-label"><i class="fab fa-twitter"></i></span>
                        <span class="btn-text">Twitter</span>
                    </a>
                    <a class="btn btn-grey btn-block btn-wth-icon mt-15" :href="API_URL + '/api/auth/github'">
                        <span class="icon-label"><i class="fab fa-github"></i></span>
                        <span class="btn-text">GitHub</span>
                    </a>
                    <a class="btn-cu btn-m  btn-fw btn-color-estandar mt-15" :href="API_URL + '/api/auth/clave_unica'" title="Este es el botón Iniciar sesión de ClaveÚnica">
                        <span class="cl-claveunica"></span>
                        <span class="texto">Iniciar sesión</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
  /*
    BTN Clave Única.
    Estilos gráficos para el botón de clave única.
    V 1.1.0
    por @pyanez
    24/11/2020
  */


  /* Boton estilo de base */
  .btn-cu {
    /*display: inline-block;*/
    display: flex;
    justify-content: center;
    font-family: Roboto, sans-serif;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-radius: 0;
  }

  /*Icono ClaveÚnica*/
  .btn-cu .cl-claveunica {
    display: inline;
    float: left;
    text-indent: -9999px;
  }
  /*Texto ClaveÚnica*/
  .btn-cu .texto {
    padding-left: 3px;
    text-decoration: underline;
  }

  /* Tamaño S */
  .btn-cu.btn-s {
    width: 130px;
    min-width: 130px;
    height: 36px;
    padding: 8px 10px !important;
    font-size: 14px;
  }

  .btn-cu.btn-s .cl-claveunica {
    width: 20px;
    height: 20px;
    background-size: 20px 20px;
  }

  /* Tamaño M */
  .btn-cu.btn-m {
    width: 160px;
    min-width: 160px;
    height: 42px;
    padding: 8px 18px 8px 15px !important;
    font-size: 16px;
    line-height: 1.6em;
  }

  .btn-cu.btn-m .cl-claveunica {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
  }

  /* Tamaño L */
  .btn-cu.btn-l {
    width: 180px;
    min-width: 180px;
    height: 48px;
    padding: 11px 18px !important;
    font-size: 18px;
  }

  .btn-cu.btn-l .cl-claveunica {
    width: 26px;
    height: 26px;
    background-size: 26px 26px;
  }

  /* Tamaño fluid-width */
  .btn-cu.btn-fw {
    max-width: 550px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  /* Color Estandar */
  .btn-cu.btn-color-estandar {
    background-color: #0F69C4;
    color: #FFF;
  }
  .btn-cu.btn-color-estandar .cl-claveunica {
    background: url('../assets/img/cu-blanco.svg');
    /* Esta URL debe ser modificada segun donde 
        quede alojado el documento */
  }
  .btn-cu.btn-color-estandar:hover {
    background-color: #0C549C;
    color: #FFF;
  }

  .btn-cu.btn-color-estandar:active {
    background-color: #093F75;
    color: #FFF;
  }

  .btn-cu.btn-color-estandar:focus {
    background-color: #0C549C;
    color: #FFF;
    outline: 1px dashed #000;
  }
</style>

<script>
    import { API_URL } from '../backend/data_server';
    import Loading from 'vue-loading-overlay';
    import Recaptcha from '../components/Recaptcha.vue';

    export default {
        name: 'Login',
        components: {
            Loading,
            Recaptcha
        },
        data() {
            return {
                userCredentials: {
                    email: null,
                    password: null,
                    remember_me: false
                },
                error: false,
                passwordFieldType: 'password',
                loadBtnLogin: false,
                fullPage: false,
                color: '#ffffff',
                recaptcha: false,
                mode: String,
                API_URL
            };
        },
        mounted() {
            if((this.$store.getters.modo_oscuro === 'dark') || (window.location.href.includes('dark'))) {
                this.mode = 'dark';
            } else {
                this.mode = 'light';
            }
        },
        methods: {
            validateRecaptcha () {
                this.recaptcha = true
            },

            login() {
                this.loadBtnLogin = true;
                this.$store.dispatch('login', this.userCredentials)
                    .then(() => {
                        this.$toastr('success', this.$t('login.contenido.mensajes.exito.generico.cuerpo'), this.$t('login.contenido.mensajes.exito.generico.titulo'));
                        this.loadBtnLogin = false;
                        this.error = false;
                        this.$router.push('/');
                    })
                    .catch(() => {
                        this.loadBtnLogin = false;
                        this.error = this.$t('login.contenido.mensajes.fallido.generico.titulo') + ': ' + this.$t('login.contenido.mensajes.fallido.generico.cuerpo') + '.';
                        this.$toastr('error', this.$t('login.contenido.mensajes.fallido.generico.cuerpo'), this.$t('login.contenido.mensajes.fallido.generico.titulo'));
                    });
            },
            switchPasswordVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
            }
        }
    };
</script>